import React from 'react';
import PropTypes from 'prop-types';
import glamorous from 'glamorous';
import {SectionPlaceholder, Content} from '../../../../../shared/library/cards/card';
import {BASE_TEXT} from '../../../../../shared/style/typography';
import {CHARCOAL, TARMAC} from '../../../../../shared/style/colors';
import {PHONE, LAPTOP} from '../../../../../shared/style/breakpoints';
import LazyLoadImage from '../../../../../shared/utils/lazy-loading-images';
import sanitizeData from './../../../../../shared/utils/sanitize-data';

const MOBILE_PADDING = 10;

const Container = glamorous.div({
  ...BASE_TEXT,
  color: TARMAC,
  ' strong': {
    color: CHARCOAL
  },
  display: 'flex',
  [PHONE]: {
    padding: MOBILE_PADDING
  },
  [LAPTOP]: {
    flexDirection: 'column',
    alignItems: 'center'
  }
});

const ImageWrapper = glamorous.div({
  width: '100%',
  maxWidth: 360,
  height: '100%',
  borderRadius: 4,
  boxShadow: '0 1px 0 0 #e1e1e1',
  border: 'solid 1px #e1e1e1',
  display: 'none',
  [PHONE]: {
    display: 'block'
  }
});

const Image = glamorous.img({
  width: '100%',
  minHeight: '100%'
});

const TopContentCard = ({description, title, screenshot}) => {
  return (
    <Container>
      {description !== '' && (
        <Content
          dangerouslySetInnerHTML={{
            __html: sanitizeData(description)
          }}
        />
      )}
      {description === '' && <SectionPlaceholder>No description found</SectionPlaceholder>}
      {screenshot && screenshot.length !== 0 && (
        <ImageWrapper>
          <LazyLoadImage>
            <Image src={screenshot} alt={title} />
          </LazyLoadImage>
        </ImageWrapper>
      )}
    </Container>
  );
};

TopContentCard.propTypes = {
  description: PropTypes.string,
  title: PropTypes.string,
  screenshot: PropTypes.string
};

export default TopContentCard;
